export default __webpack_public_path__ + "5a9ff77492a1efe7f946e424a356a3cd.png";